import type { OverWritable } from '../../@types/settings';

export const controlLabel: OverWritable = {
  MuiFormControlLabel: {
    styleOverrides: {
      label: {
        // ...theme.typography.body2,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: ({ theme }) => ({
        marginTop: theme.spacing( 1 ),
      }),
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.text.disabled,
      }),
    },
  },
};
